import React from "react";
import cx from "classnames";
import { PageLink } from "src/components/link";
import { useToggleContact } from "src/context/siteContext";
import styles from "./coliving-menu.module.css";

export const ColivingMenu = ({
  buildingSlug = `the-agnes`,
  applicationUrl
}: {
  buildingSlug: string;
  applicationUrl: string;
}) => {
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div className={styles.colivingMenu}>
        <ul>
          <li className={styles.menuItem}>
            <button
              className={cx("sans sans--caps-11 medium", styles.menuLink)}
              onClick={() => scrollToSection("coliving-availability")}
            >
              Co-living Availability
            </button>
          </li>
          <li className={styles.menuItem}>
            <button
              className={cx("sans sans--caps-11 medium", styles.menuLink)}
              onClick={() => scrollToSection("coliving-contact")}
            >
              Contact
            </button>
          </li>
          <li className={styles.menuItem}>
            <a
              // href={applicationUrl}
              href={
                "https://theagnescoliving.securecafe.com/onlineleasing/agnes-c/guestlogin.aspx"
              }
              target="_blank"
              rel="noopener noreferrer"
              className={cx("sans sans--caps-11 medium", styles.menuLink)}
            >
              Apply Now
            </a>
          </li>
          <li className={styles.menuItem}>
            <a
              href={`https://theagnescoliving.securecafe.com/residentservices/agnes-c/userlogin.aspx`}
              className={cx("sans sans--caps-11 medium", styles.menuLink)}
              target="_blank"
              rel="noopener noreferrer"
            >
              Co-living Resident Portal
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};
